import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog(props) {
    var { message, children, isOpen, setOpen } = props;

    return (
        <div>
          <Dialog
            open={isOpen}
            onClose={setOpen}
            // wait="2000"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            {/* <DialogTitle id="alert-dialog-title">{message}</DialogTitle> */}
            <DialogContent >
              <DialogContentText id="alert-dialog-description">
                {message}
              </DialogContentText>
            </DialogContent>
            <DialogActions  >
                {children}
            </DialogActions>
          </Dialog>
        </div>
      );
}